<template>
  <div class="filter-panel h-100 d-flex flex-column">
    
    <!-- Header Filtros -->
    <div class="d-flex align-center justify-space-between mb-6 pb-2 border-b">
      <div class="d-flex align-center">
        <v-icon style="font-size: 14px; color: #002B49;" class="mr-2">fa:fa-solid fa-filter</v-icon>
        <h3 class="text-subtitle-2 font-weight-bold text-grey-darken-3 text-uppercase ls-1">Filtros Avanzados</h3>
      </div>
      <!-- Opcional: Podríamos agregar un botón de reset aquí en el futuro -->
    </div>

    <!-- Scrollable Content -->
    <div class="flex-grow-1 overflow-y-auto pr-2 custom-scrollbar">
      
      <div v-if="!visitor" class="mb-4">
        <v-select label="Agentes" placeholder="Seleccionar agentes..." variant="outlined" density="comfortable" color="primary" bg-color="white"
          hide-details="auto" clearable clear-icon="" :items="listAgentes" item-title="user.nombres" item-value="idagente" 
          v-model="filters.agentes" multiple chips closable-chips>
          <template v-slot:prepend-inner>
            <v-icon style="font-size: 14px; color: #9E9E9E;" class="mr-2">fa:fa-solid fa-user-tie</v-icon>
          </template>
          <template v-slot:clear>
             <v-icon style="font-size: 14px; color: #9E9E9E;">fa:fa-solid fa-xmark</v-icon>
          </template>
        </v-select>
      </div>

      <div class="mb-4">
        <v-select label="Tipo de Ticket" placeholder="Todos" variant="outlined" density="comfortable" color="primary" bg-color="white"
          hide-details="auto" clearable clear-icon="" :items="listTipo" item-title="nombre" item-value="idtipo" 
          v-model="filters.tipo">
          <template v-slot:prepend-inner>
            <v-icon style="font-size: 14px; color: #9E9E9E;" class="mr-2">fa:fa-solid fa-tag</v-icon>
          </template>
          <template v-slot:clear>
             <v-icon style="font-size: 14px; color: #9E9E9E;">fa:fa-solid fa-xmark</v-icon>
          </template>
        </v-select>
      </div>

      <div class="mb-4">
        <v-select label="Prioridad" placeholder="Todas" variant="outlined" density="comfortable" color="primary" bg-color="white"
          hide-details="auto" clearable clear-icon="" :items="listPrioridad" item-title="nombre" item-value="idprioridad" 
          v-model="filters.prioridad">
          <template v-slot:prepend-inner>
            <v-icon style="font-size: 14px; color: #9E9E9E;" class="mr-2">fa:fa-solid fa-triangle-exclamation</v-icon>
          </template>
          <template v-slot:clear>
             <v-icon style="font-size: 14px; color: #9E9E9E;">fa:fa-solid fa-xmark</v-icon>
          </template>
        </v-select>
      </div>

      <div class="mb-4">
        <v-select label="Categoría" placeholder="Todas" variant="outlined" density="comfortable" color="primary" bg-color="white"
          hide-details="auto" clearable clear-icon="" :items="listCategorias" item-title="nombre" item-value="idcategoria" 
          v-model="filters.categoria">
          <template v-slot:prepend-inner>
            <v-icon style="font-size: 14px; color: #9E9E9E;" class="mr-2">fa:fa-solid fa-folder-tree</v-icon>
          </template>
          <template v-slot:clear>
             <v-icon style="font-size: 14px; color: #9E9E9E;">fa:fa-solid fa-xmark</v-icon>
          </template>
        </v-select>
      </div>

      <div class="mb-4">
        <v-select label="Estado" placeholder="Todos" variant="outlined" density="comfortable" color="primary" bg-color="white"
          hide-details="auto" clearable clear-icon="" :items="listEstados" item-title="nombre" item-value="idestado" 
          v-model="filters.estado">
          <template v-slot:prepend-inner>
            <v-icon style="font-size: 14px; color: #9E9E9E;" class="mr-2">fa:fa-solid fa-circle-check</v-icon>
          </template>
          <template v-slot:clear>
             <v-icon style="font-size: 14px; color: #9E9E9E;">fa:fa-solid fa-xmark</v-icon>
          </template>
        </v-select>
      </div>

      <div class="mb-4">
        <v-text-field label="Fecha" type="date" variant="outlined" density="comfortable" color="primary" bg-color="white"
          hide-details="auto" clearable clear-icon="" v-model="filters.fecha">
          <template v-slot:prepend-inner>
            <v-icon style="font-size: 14px; color: #9E9E9E;" class="mr-2">fa:fa-solid fa-calendar-days</v-icon>
          </template>
          <template v-slot:clear>
             <v-icon style="font-size: 14px; color: #9E9E9E;">fa:fa-solid fa-xmark</v-icon>
          </template>
        </v-text-field>
      </div>

      <div v-if="!visitor" class="mb-4">
        <v-text-field label="Contacto" placeholder="DNI, Nombre o Apellido" variant="outlined" density="comfortable" color="primary" bg-color="white"
          hide-details="auto" clearable clear-icon="" v-model="filters.dninombre">
          <template v-slot:prepend-inner>
            <v-icon style="font-size: 14px; color: #9E9E9E;" class="mr-2">fa:fa-solid fa-address-card</v-icon>
          </template>
          <template v-slot:clear>
             <v-icon style="font-size: 14px; color: #9E9E9E;">fa:fa-solid fa-xmark</v-icon>
          </template>
        </v-text-field>
      </div>

      <div v-if="!visitor" class="mb-4">
        <v-select label="Tipo de Persona" placeholder="Todos" variant="outlined" density="comfortable" color="primary" bg-color="white"
          hide-details="auto" clearable clear-icon="" :items="['COLABORADOR', 'ESTUDIANTE']" v-model="filters.tiposolicitante">
          <template v-slot:prepend-inner>
            <v-icon style="font-size: 14px; color: #9E9E9E;" class="mr-2">fa:fa-solid fa-users</v-icon>
          </template>
          <template v-slot:clear>
             <v-icon style="font-size: 14px; color: #9E9E9E;">fa:fa-solid fa-xmark</v-icon>
          </template>
        </v-select>
      </div>

    </div>

    <!-- Botón de Acción -->
    <div class="pt-4 mt-auto">
      <v-btn block size="large" rounded="lg" color="primary" elevation="2" @click="getTicketsFilter()"
        style="background: linear-gradient(135deg, #002B49 0%, #005691 100%);">
        <v-icon style="font-size: 14px; color: #FFFFFF;" class="mr-2">fa:fa-solid fa-filter</v-icon>
        Aplicar Filtros
      </v-btn>
    </div>

  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex';


export default {

  props:
  {
    visitor:{
      type: Boolean,
      default: false
    }
  },
  computed:{
    ...mapState(['user']),
    ...mapState("tickets", ["filters"]),
    ...mapState("configuracion/tipo", ["listTipo"]),
    ...mapState("configuracion/categoria", ["listCategorias", "loading"]),
    ...mapState("configuracion/prioridad", ["listPrioridad"]),
    ...mapState("configuracion/estado", ["listEstados"]), 
    ...mapState("configuracion/agente", ['listAgentes'])
  },
  methods:{
    ...mapActions("tickets", ["getTicketsAxios"]),

    getTicketsFilter()
    {
      if(this.visitor)
      {
        this.getTicketsAxios({loading: true, iduser: this.user.iduser, page: 1})
      }else
      {
        this.getTicketsAxios({loading: true, page:1}); 
      }
    }
  }
}
</script>

<style scoped>
.ls-1 {
  letter-spacing: 1px;
}

/* Custom scrollbar para que sea sutil */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #E0E0E0;
  border-radius: 20px;
}
</style>